export const ACTIVE_APPOINTMENT_STATUSES = new Set([
  "Scheduled",
  "Confirmed",
  "Checked In",
  "Pencil",
]);

export function normalizeAppointmentStatus(status) {
  if (status === "CheckedIn") return "Checked In";
  if (status === "NoShow") return "No Show";
  return status || "Scheduled";
}

export function isBlockingAppointmentStatus(status) {
  return ACTIVE_APPOINTMENT_STATUSES.has(normalizeAppointmentStatus(status));
}
